import { render, staticRenderFns } from "./TicketDetailsSupervisor.vue?vue&type=template&id=06d9e2b4&"
import script from "./TicketDetailsSupervisor.vue?vue&type=script&lang=js&"
export * from "./TicketDetailsSupervisor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports